/* facts-social.js · FACTS Section-Standard v1
   ------------------------------------------------------------------
   Zwei Aufgaben, mehr nicht:
   1. Videos laufen stumm und nur, solange sie im Bild sind. Ein Video,
      das hinter dem Fenster weiterlaeuft, kostet Akku und sagt niemandem
      etwas.
   2. Der Ton laesst sich je Karte einschalten. Schaltet man einen ein,
      gehen die anderen aus - zwei Stimmen gleichzeitig sind keine.

   Ohne Javascript bleiben die Videos stumm, in Schleife, mit `autoplay`
   und `playsinline` aus dem Markup. Der Tonknopf ist dann sichtbar, aber
   wirkungslos - deshalb wird er per Javascript eingehaengt und ist im
   Markup von vornherein `hidden`.
*/
(function () {
  'use strict';

  function boot(root) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-fso-video]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-fso-sound]'));
    if (!videos.length) return;

    if (root.dataset.fsoInitialized) return;
    root.dataset.fsoInitialized = 'true';

    function loadPoster(v) {
      var poster = v.getAttribute('data-fso-poster');
      if (poster) { v.poster = poster; v.removeAttribute('data-fso-poster'); }
    }
    if ('IntersectionObserver' in window) {
      var posters = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadPoster(entry.target); posters.unobserve(entry.target); }
        });
      }, { rootMargin: '500px' });
      videos.forEach(function (v) { posters.observe(v); });
    } else { videos.forEach(loadPoster); }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    buttons.forEach(function (b) { b.hidden = false; });

    function quelleEinhaengen(v) {
      loadPoster(v);
      var url = v.getAttribute('data-fso-src');
      if (!url) return false;
      v.removeAttribute('data-fso-src');
      var q = document.createElement('source');
      q.src = url;
      q.type = 'video/mp4';
      v.appendChild(q);
      v.load();
      return true;
    }


    function stummAlle(ausser) {
      videos.forEach(function (v) {
        if (v === ausser) return;
        v.muted = true;
        var b = v.parentNode.querySelector('[data-fso-sound]');
        if (b) b.setAttribute('aria-pressed', 'true');
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.parentNode;
        var v = card.querySelector('[data-fso-video]');
        if (!v) return;
        quelleEinhaengen(v);
        if (v.muted) {
          stummAlle(v);
          v.muted = false;
          b.setAttribute('aria-pressed', 'false');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.muted = true;
          b.setAttribute('aria-pressed', 'true');
        }
      });
    });

    // Julian 03.09.: die Videos sollen die Ladezeit nicht mehr belasten.
    // In der Stellung "spaet" traegt das <video> nur ein Standbild und die
    // Adresse in `data-fso-src`. Die Quelle wird erst eingehaengt, wenn die
    // Karte ins Bild kommt - vorher laedt der Browser keinen einzigen Byte
    // des Films. Ohne Javascript bleibt das Standbild stehen; das ist die
    // ehrlichere Rueckfallebene als ein leeres Rechteck.
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        var v = es[i].target;
        if (es[i].isIntersecting) {
          quelleEinhaengen(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
          // Verlaesst ein tonfuehrendes Video das Bild, geht der Ton aus -
          // sonst spricht eine Karte weiter, die niemand mehr sieht.
          if (!v.muted) {
            v.muted = true;
            var b2 = v.parentNode.querySelector('[data-fso-sound]');
            if (b2) b2.setAttribute('aria-pressed', 'true');
          }
        }
      }
    }, { threshold: 0.35 });

    videos.forEach(function (v) { io.observe(v); });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-fso]');
    for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-fso]');
    if (el) boot(el);
  });
})();
